export class OmniCameraFrameSampler {
  private stream?: MediaStream;
  private video?: HTMLVideoElement;
  private canvas?: HTMLCanvasElement;

  async start(constraints: MediaStreamConstraints = { video: { facingMode: "user" }, audio: false }) {
    if (this.stream) return;
    this.stream = await navigator.mediaDevices.getUserMedia(constraints);
    this.video = document.createElement("video");
    this.video.muted = true;
    this.video.playsInline = true;
    this.video.srcObject = this.stream;
    await this.video.play();
    this.canvas = document.createElement("canvas");
  }

  captureJpegBase64(quality = 0.72) {
    if (!this.video || !this.canvas || this.video.videoWidth === 0 || this.video.videoHeight === 0) return undefined;
    this.canvas.width = this.video.videoWidth;
    this.canvas.height = this.video.videoHeight;
    const context = this.canvas.getContext("2d");
    if (!context) return undefined;
    context.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);
    return stripDataUrlPrefix(this.canvas.toDataURL("image/jpeg", quality));
  }

  stop() {
    this.stream?.getTracks().forEach((track) => track.stop());
    if (this.video) this.video.srcObject = null;
    this.stream = undefined;
    this.video = undefined;
    this.canvas = undefined;
  }
}

function stripDataUrlPrefix(value: string) {
  const marker = ";base64,";
  const index = value.indexOf(marker);
  return index >= 0 ? value.slice(index + marker.length) : value;
}
